<template>
  <v-dialog v-model="dialog" persistent max-width="500px" scrollable>
    <v-card
      style="border-radius:20px;"
      class="py-2 strategio-card-container"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >
        Actualizando reportes
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <v-container>
          <!-- {{items}} -->
          <v-layout column>
            <v-flex
              :key="index"
              v-for="(item, index) in items"
            >
              <v-layout column>
                <v-flex>
                  <!-- {{item}}<br> -->
                  En <b>{{item.parentName}}</b><br>
                  <!-- :rules="[validateUrls()]" -->
                </v-flex>
                <v-flex>
                  <v-layout column>
                    <v-flex>
                      <v-text-field
                        clearable
                        v-model="item.url1"
                        label="URL principal"
                        hint="Esta URL es opcional si ya tenemos URL de descarga"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        clearable
                        v-model="item.url2"
                        label="URL de descarga"
                        hint="Esta URL es opcional si ya tenemos URL principal"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>

        </v-container>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          :color="!anyItemToUpdate ? 'red darken-2' : 'grey darken-2'"
          style="color:white;"
          @click.native="dialog = false"
        >Ignorar</v-btn>
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          :disabled="!anyItemToUpdate"
          style="background-color:#61B965;color:white;"
          @click.native="update"
        >Grabar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {map, filter, assign, reduce} from 'lodash'

import structureStorage from '../../storage/structureStorage'

import eventBus from './../../utils/eventBus'

export default {
  data () {
    return {
      dialog: false,
      items: [
        /* {
          itemID: 113,
          parentName: 'FolderEstructurado0-H1-01',
          url1: '',
          url2: ''
        },
        {
          itemID: 114,
          parentName: 'FolderEstructurado0-H1-02',
          url1: '',
          url2: ''
        },
        {
          itemID: 115,
          parentName: 'FolderEstructurado0-H1-03',
          url1: '',
          url2: ''
        } */
      ],
      data: {
        url1s: [],
        url2s: []
      }
    }
  },
  created () {
    eventBus.$off('open-new-items-manager-dialog')
    eventBus.$on('open-new-items-manager-dialog', (data) => {
      map(data.items, (item) => {
        assign(item, {url1: '', url2: ''})
      })

      // console.log('!!!!!!!!!!!!!!!', JSON.stringify(items, null, 2))
      // this.items.splice(0)
      // this.items.push(...items)
      this.items = data.items

      this.dialog = true
    })
  },
  computed: {
    anyItemToUpdate () {
      return reduce(this.items, (total, item) => {
        return total || !!(item.url1 || item.url2)
      }, false)
    }
  },
  methods: {
    update () {
      const filteringItemsToUpdate = () => {
        return filter(this.items, (item) => {
          return !!(item.url1 || item.url2)
        })
      }

      if (this.anyItemToUpdate) {
        // console.log('updating..' + filteringItemsToUpdate().length, JSON.stringify(filteringItemsToUpdate(), null, 2))
        structureStorage.updateSpecificItemData({
          data: {
            items: filteringItemsToUpdate()
          },
          onSuccess: () => {
            // console.log('SUCCESS')
            eventBus.$emit('open-custom-snack-bar', {message: 'Reportes actualizados correctamente', itsOk: true})

            eventBus.$emit('reload-items')
            this.dialog = false
          },
          onError: (error) => {
            console.warn('Error actualizando reportes: ', error)
            eventBus.$emit('open-custom-snack-bar', {message: 'Error actualizando reportes', itsOk: false})
          }
        })
      } else {
        // console.log('No hay items que actualizar')
      }
    }
    /* validateUrls () {
      if ((this.data.url1 && this.data.url1.trim() !== '') || (this.data.url2 && this.data.url2.trim() !== '')) {
        return true
      }
      return 'Este campo es obligatorio'
    } */
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/new-items-manager-dialog.vue